import { FC, useEffect, useState } from 'react';
import { useAppSelector } from '../../redux/hooks';
import AddPaymentMethodModal, { initialPaymentState } from '../../components/payment-method-modal/AddPaymentMethodModal';
import AlertSVG from '../../components/svgs/Alert.svg';
import LockSVG from '../../components/svgs/Lock.svg';
import { centsToDollars } from '../../services/account.service';
import { getPaymentDetails } from '../../services/payment.service';
import { PaymentMethod } from '../../types/interfaces/paymentMethod.interface';
import { BUTTON_CONSTANTS, NOTIFICATION_CONSTANTS } from '../../constants/common';

const OnFarmOutstandingBalanceBanner: FC = () => {
  const { accountId, onFarmOutstandingBalanceCents, isOnFarmBlocked } = useAppSelector(state => state.activeAccount);
  const [addPaymentMethodModalVisible, setAddPaymentMethodModalVisible] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState<PaymentMethod>(initialPaymentState);
  const hasDueBalance = onFarmOutstandingBalanceCents > 0;

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      if (!accountId) return;
      const paymentData = await getPaymentDetails(accountId);
      paymentData && setPaymentInfo(paymentData);
    };

    fetchPaymentDetails();
  }, [addPaymentMethodModalVisible, accountId]);

  if (!hasDueBalance && !isOnFarmBlocked) {
    return null;
  }

  return (
    <>
      <section className={`on-farm-status-banner on-farm-status-banner--${hasDueBalance ? 'due' : 'locked'}`}>
        <div className="on-farm-status-banner__icon">{hasDueBalance ? <AlertSVG /> : <LockSVG />}</div>
        <p className="on-farm-status-banner__copy">
          {hasDueBalance ? (
            <>
              {NOTIFICATION_CONSTANTS.ON_FARM_BALANCE_DUE_PREFIX}{' '}
              <strong>{`$${centsToDollars(onFarmOutstandingBalanceCents)}`}</strong>
              {`. ${NOTIFICATION_CONSTANTS.ON_FARM_BALANCE_DUE_SUFFIX}`}
            </>
          ) : (
            <>
              {NOTIFICATION_CONSTANTS.ON_FARM_LOCKED_PREFIX} <strong>locked</strong>
              {`. ${NOTIFICATION_CONSTANTS.ON_FARM_LOCKED_SUFFIX}`}
            </>
          )}
        </p>
        {hasDueBalance && (
          <button
            className="button green small on-farm-status-banner__action"
            type="button"
            onClick={() => setAddPaymentMethodModalVisible(true)}>
            {BUTTON_CONSTANTS.PAY_NOW}
          </button>
        )}
      </section>
      {accountId && addPaymentMethodModalVisible && (
        <AddPaymentMethodModal
          title={BUTTON_CONSTANTS.PAY_NOW}
          accountId={accountId}
          paymentDetails={paymentInfo}
          isOpen={addPaymentMethodModalVisible}
          setIsOpen={setAddPaymentMethodModalVisible}
          onclick={() => setAddPaymentMethodModalVisible(false)}
          buttonAction="PayNow"
          isOnFarmPayNow
        />
      )}
    </>
  );
};

export default OnFarmOutstandingBalanceBanner;
